<template>
<div class="paddingh30 borderb bg-white" :class="show == 'my' ? 'paddingt20' : 'paddingt40'">
    <!-- 头像区 -->
    <div class="flex-container">
        <div class="flex-container left flex1">
            <div class="pos-r">
                <div>
                    <a :href="show=='my'?data.headerClickUrl.replace('hisDiscover', 'myDiscover'):data.headerClickUrl" v-if="!inMyPage" :data-scp="$options.name+'.00'">
                        <div style="width:35px;height:35px;overflow: hidden;" class="border-round"><img alt="" width="100%" :src="data.headImageUrl"></div>
                    </a>
                    <div style="width:35px;height:35px;overflow: hidden;" class="border-round" v-if="inMyPage"><img alt="" width="35" height="35" class="border-round" :src="data.headImageUrl"></div>
                </div>
                <div v-show="data.roleType == 4" class="member pos-a border-round text-center right0 bottom0 bg-red">
                    <!-- <i class="icon-pd_crown text-white fs-10 text-white"></i> -->
                </div>
            </div>
            <div class="paddingl20 flex1 pos-r">
                <!-- 右上角的推荐图标 仅发现首页 -->
                <div class="pos-a" :class="(dataIndex < 5)?'essenceIcon':((dataIndex >= 5 && dataIndex < 20)?'recommendIcon':'')" v-show="showRecommendIcon"></div>
                <div class="text-limit1">
                    <span class="text-darker fs-14" v-text="data.nickName" style="font-weight: bold;"></span>
                    <span class="fs-11 paddingl20 text-red" v-show="data.roleType == 4 ">
                        <i class="icon-discover_daren fs-10"></i><span>官方</span>
                    </span>
                </div>
                <div class="text-light fs-10 text-limit1">
                    <span>{{data.timeStr}}</span>
                    <!-- <span class="paddingl20">{{data.storeName}}</span> -->
                </div>
            </div>
        </div>
        <!-- 首页去掉聊聊和关注 -->
        <!-- <div>
            <div style="background: none" :data-scp="$options.name+'.chat'" class="badge badge-reverse badge-green badge-big badge-pill fs-15 text-green" v-if="!(show == 'my') && !inHisPage">
                <div class="clearfix">
                    <span class="icon-chat fs-14 lh-12 dis-i float-left"></span>
                    <span class="dis-i float-left paddingl10 fs-11" v-on:click="chat(data.memberId)" style="line-height: 14px;">聊聊</span>
                </div>
            </div>
            <div style="background: none"
                 class="badge badge-reverse badge-big badge-pill fs-15 text-green marginl20"
                 :data-scp="$options.name+'.follow'"
                 :class="data.hasConcerned?'':'badge-red'"
                 v-if="!(show == 'my') && !inHisPage">
                <div class="clearfix">
                    <span class="dis-i float-left paddingl10 fs-11" style="line-height: 14px;" @click="concern(data.memberId, data.hasConcerned, data)" v-text="data.hasConcerned?'已关注':'+ 关注'"></span>
                </div>
            </div>
        </div> -->
        <div v-if="show == 'my' && inMyPage" @click="delDiscover(data.id)">
            <i class="icon-unfold fs-16"></i>
        </div>
    </div>
    <!-- 内容区 -->
    <a :href="data.clickUrl" :data-scp="$options.name+'.01'" v-if="data.content||!data.content">
        <pre class="text-darker paddingt40"
             :class="'text-limit3'"
             style="word-wrap:break-word;white-space: pre-wrap;font-family:microsoft yahei;overflow: hidden;"
             v-text="data.content||data.imageUrls[0].content"></pre>
    </a>
    <div>
        <div class="marginh10 text-light dis-i" v-if="data.attentions" v-for="item in data.attentions" v-text="'@'+ item.nickName"></div>
    </div>
    <!-- 门店位置 -->
    <!-- <div class="margint20 flex-container left text-green">
        
        <div class="flex1 fs-11 marginl10"><a :href="data.storeUrl" class="text-green" :data-scp="$options.name+'.07'">{{data.storeName}}</a></div>
    </div> -->
    <!-- 门店位置和标签 -->
    <div class="flex-container margint20">
        <div class="flex-container">
            <i class="icon-store_position fs-11" style="color:#25aaff"></i>
            <div class="fs-11 marginl10"><a :href="data.storeUrl" style="color:#25aaff" :data-scp="$options.name+'.07'">{{data.storeName}}</a></div>
        </div>
        <div class="flex-container fs-11 text-lighter">
            <div v-for="item in data.labels"><span class="padding10">{{item.labelName}}</span><span v-show="$index !== (data.labels.length-1)">|</span></div>
        </div>
    </div>
    <!-- 图片区 列表页-->
    
        <a :href="data.clickUrl" class="dis-b" :data-scp="$options.name+'.02'">
            <div class="box-row margint20" v-if="data.imageUrls.length === 1"><!-- 一张图 -->
                <div class="box-span7" v-for="item in data.imageUrls">
                    <div class="ratio-container">
                        <div class="tgDefaultBg"></div>
                        <div class="border-radius" :style="'background:url('+item.imageUrl+') center no-repeat;background-size: cover;'">
                        </div>
                        <div class="discoverPlay border-round flex-container center" v-show="item.videoUrl">
                            <i class="icon-discover_play text-white fs-20"></i>
                        </div>
                        <div class="discover_tag pos-a top0 left0" v-text="data.labels.labelName" :class="'label_'+ (data.labels.tagBg||'1')" v-if="data.labels.labelName"></div>
                    </div>
                </div>
            </div>
            <div class="box-row margint20" v-if="data.imageUrls.length === 2"><!-- 两张图 -->
                <div class="box-span6 paddingr10" v-for="item in data.imageUrls">
                    <div class="ratio-container-17x20">
                        <div class="tgDefaultBg"></div>
                        <div class="border-radius" :style="'background:url('+item.imageUrl+') center no-repeat;background-size: cover;'">
                        </div>
                        <div class="discoverPlay border-round flex-container center" v-show="item.videoUrl">
                            <i class="icon-discover_play text-white fs-20"></i>
                        </div>

                        <div class="discover_tag pos-a top0 left0" v-text="data.labels.labelName" :class="'label_'+ (data.labels.tagBg||'1')" v-if="data.labels.labelName && $index === 0"></div>
                    </div>
                </div>
            </div>
            <div class="box-row margint20" v-if="data.imageUrls.length >2"><!-- 三张图以上 -->
                <cmui-list :col="[7,5]" :space="10">
                    <cmui-list-item>
                        <div class="ratio-container">
                            <div class="tgDefaultBg"></div>
                            <div class="border-radius" :style="'background:url('+data.imageUrls[0].imageUrl+') center no-repeat;background-size: cover;'">
                                <!-- <span class="label_1 fs-11 lh-16 text-white dis-i float-left paddingh10">大商热卖</span> -->
                            </div>
                            <div class="discoverPlay border-round flex-container center" v-show="data.imageUrls[0].videoUrl">
                                <i class="icon-discover_play text-white fs-20"></i>
                            </div>

                            <div class="discover_tag pos-a top0 left0" v-text="data.labels.labelName" :class="'label_'+ (data.labels.tagBg||'1')" v-if="data.labels.labelName"></div>
                        </div>
                    </cmui-list-item>
                    <cmui-list-item>
                        <div class="ratio-container-7x5 marginb10">
                            <div class="tgDefaultBg"></div>
                            <div class="border-radius" :style="'background:url('+data.imageUrls[1].imageUrl+') center no-repeat;background-size: cover;'"></div>
                            <div class="discoverPlay border-round flex-container center" v-show="data.imageUrls[1].videoUrl">
                                <i class="icon-discover_play text-white fs-20"></i>
                            </div>
                        </div>
                        <div class="ratio-container-7x5 marginb10">
                            <div class="tgDefaultBg"></div>
                            <div class="border-radius" :style="'background:url('+data.imageUrls[2].imageUrl+') center no-repeat;background-size: cover;'"></div>
                            <div class="discoverPlay border-round flex-container center" v-show="data.imageUrls[2].videoUrl">
                                <i class="icon-discover_play text-white fs-20"></i>
                            </div>
                        </div>
                    </cmui-list-item>
                </cmui-list>
                <span v-if="data.imageNum > 3" class="pos-a bottom20 right20 text-white" style="font-size: 0.58667rem;text-shadow: 3px 3px 3px #666;-webkit-text-shadow: 3px 3px 3px #666;" v-text="'+'+data.imageNum"></span>
            </div>
        </a>
    
    <!-- 评论区 -->
    <!-- 评论区20180731后取消 -->
    <!-- <div style="background:#f8f8f8" class="padding20 margint20" v-show="data.comments" v-if="!(inMyPage||inHisPage)">
        <a :href="data.clickUrl" class="text-light" :data-scp="$options.name+'.03'">
            <div v-for="(index,product) in data.comments" class="fs-11 text-limit1 lh-16" v-if="data.comments[index]">
                <span v-text="product.nickName" class="text-darker"></span>
                <span class="fs-11 text-red" v-show="product.reviewerType == 4 ">
                    <i class="icon-discover_daren fs-10"></i>
                    <span>官方</span>
                </span>: 
                <span v-text="product.content" class="text-dark"></span>
            </div>
        </a>
    </div> -->
    <!-- 商品区 -->
    <div @click.prevent.stop="goProduct(item.clickUrl,'.goProduct'+item.itemId+'.'+index)" class="padding10 flex-container top margint10" v-for="(index,item) in data.products" :data-scp="'goProduct'+item.itemId+'.'+index" style="background-color: #F8F8F8;border-radius: 8px;" v-show='showProductFold === true? index === 0:true '>
        <div class="ratio-container img-container border" style="min-width: 60px;border-radius:4px">
            <img :src="item.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img/bg-load.png!s'" width="60" height="60" alt="">
        </div>
        <div class="marginl20 margint10 flex1">
            <div class="fs-13 text-darker text-fixed1" v-text="item.title"></div>
            <div class="margint10 flex-container left">
                <div class="text-red fs-12">¥<span class="fs-20 marginl10" v-text="item.price"></span></div>
                <div class="quan fs-10 text-red marginl10 text-center pos-r" v-show="(couponObj[item.itemId] && couponObj[item.itemId].coupon) || item.coupon"><span>券</span></div>
            </div>
        </div>
        <div class="flex-container" v-show="index === 0 && data.products.length>1">
            <i class="icon-roundrightfill text-lighter" :class="showProductFold?'iconDown':'iconUp'" style="font-size: 24px;" @click.prevent.stop="showMoreProduct()"></i>
        </div>
    </div>


    <div class="box-row text-dark paddingb30 margint20 flex-container">
        <div class="flex1">
            <a :href="data.clickUrl" class="text-dark" :data-scp="$options.name+'.04'">
                <div class="flex-container left box-span3">
                    <i class="icon-discover_liuyan fs-15"></i><span class="marginl10 flex1 fs-14">{{data.commentSum}}</span>
                </div>
            </a>
            <a :href="data.clickUrl" class="text-dark" :data-scp="$options.name+'.05'">
                <div class="flex-container left box-span3">
                    <i class="icon-discover_eye fs-15"></i><span class="marginl10 flex1 fs-14">{{data.browseNum}}</span>
                </div>
            </a>
        </div>
        <div>
            <div @click="likeThis(data.id, data)" class="badge badge-reverse badge-big badge-pill" :data-scp="$options.name+'.06'">
                <div class="clearfix">
                    <span class="fs-14 dis-i float-left" :style="!data.hasLiked ? 'color:#666' : 'color:#ff4c48'" :class="!data.hasLiked ? 'icon-counter_like' : 'icon-discover_like animated bounceIn'"></span>
                    <span class="dis-i float-left paddingl10 paddingr10 text-dark fs-14">{{data.likedSum}}</span>
                </div>
            </div>
        </div>

        <!-- <div class="float-right fs-14 flex-container left text-dark" v-if="show == 'my' && inMyPage" @click="delDiscover(data.id)">
            <i class="icon-mine-idDel"></i><span class="marginl10 flex1">删除</span>
        </div> -->
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import maple from 'maple';
import tgs from '../../analyse';
export default {
    props:{
        like:{//显示喜欢
            type:Boolean,
            default:true
        },
        show:{//my:我的发现
            type:String,
            default:''
        },
        data:{
            type: Object,
            default: null
        }
        , inMyPage: {
            type: Boolean
            , default: false
        }
        , isHybrid: {
            type: Boolean
            , default: true
        }
        , inHisPage: {
            type: Boolean
            , default: false
        }
        , dataIndex: {
            type: Number
            , default: 0
        }
        , showRecommendIcon: {
            type: Boolean
            , default: false
        }
        , couponObj: {
            type: Object
            , default: {}
        }
        , showProductFold: { //发现显示的关联商品的状态，默认为收起
            type: Boolean
            , default: true
        }
    }
    , methods: {
        delDiscover(discoverId){
            this.$dispatch('delDiscover', discoverId);
        }
        /*, chat(memberId){
            this.$dispatch('chat', memberId);
        }*/
        /*, playVideo(index=0){
            if( maple.cookie('hybrid') === 'true' ){
                var imgUrl=location.protocol + this.data.imageUrls[index].imageUrl;
                var videoUrl=location.protocol + _.get(this.data,'imageUrls['+index+'].videoUrl')||this.data.videoUrl;
                this.$dispatch('playVideo', {imgUrl,videoUrl});
            }
            else{
                if( !this.videoDOMs ){
                    this.$set('videoDOMs', []);
                    let $videos=$(this.$el).find('video');
                    $videos.each((index,el)=>{
                        this.$set('videoDOMs['+index+']', $(el)[0]);
                        $(el)[0].addEventListener('click', ()=>{
                            $(el)[0].pause();
                            this.$set('videoPlaying', -1);
                        });
                        $(el)[0].addEventListener('ended', ()=>{
                            this.$set('videoPlaying', -1);
                        });
                    })
                }
                this.$set('videoPlaying', index);
                this.videoDOMs.length && this.videoDOMs[index].play();
            }
        }*/
        , likeThis: function(discoverId, index){   // 向上抛出事件，点击喜欢按钮
            this.$dispatch('likeThis', discoverId, index);
        }
        , concern: function(memberId, hasConcerned, data){
            if( hasConcerned ){
                this.$dispatch('notConcernEvent', memberId, data);
            }
            else{
                this.$dispatch('concernEvent', memberId, data);
            }
        }
        , showMoreProduct:function(){
            this.showProductFold = ! this.showProductFold;
        }
        , goProduct(url, scp){
            tgs.trackSCP(maple.pageIns.page+scp);
            maple.pageIns.changePage(url, {scp:maple.pageIns.page+scp});
        }
    }
}
</script>

<style lang="scss">
    .member{
        width:16px;
        height:16px;
        line-height: 16px;
    }
    .ratio-container-7x5,.ratio-container-17x20 {
        position: relative;
        font: 0/0 a;
        color: transparent;
        text-shadow: none;
        background-color: transparent;
        border: 0;
    }
    .ratio-container-7x5:before,.ratio-container-17x20:before {
        content: "";
        display: block;
        height: 0;
        font-size: 0;
    }
    .ratio-container-7x5:before {
        padding-top: 69%;
    }
    .ratio-container-17x20:before {
        padding-top: 118%;
    }
    .ratio-container-7x5 > *,.ratio-container-17x20 > *{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        font: initial;
        color: initial;
        overflow: hidden;
    }
    .ratio-container-7x5 > img,.ratio-container-17x20 > img {
        width: 100%;
        height: 100%;
    }
    .discoverPlay{
        width:55px;
        height:55px;
        background: rgba(0,0,0,.4);
        left:50%;
        top:50%;
        margin-left:-28px;
        margin-top:-28px;
    }
    .discoverPlay2 {
        width: 80px;
        height: 80px;
        background: #000;
        left: 50%;
        top: 50%;
        margin-left: -40px;
        margin-top: -40px;
    }
    .bottomHold .borderb {
        border-bottom: 1px solid #f3f3f3;
    }
    .tg-tabbar.theme_5 .tg-tabbar-warp {
        border-bottom: 1px solid #f3f3f3;
    }
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
    }
    @-webkit-keyframes bounceIn {
        0%,100%,20%,40%,60%,80% {
            -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
            transition-timing-function: cubic-bezier(0.215,.61,.355,1)
        }

        0% {
            opacity: 0;
            -webkit-transform: scale3d(.1,.1,.1);
            transform: scale3d(.1,.1,.1)
        }

        20% {
            -webkit-transform: scale3d(1.3,1.3,1.3);
            transform: scale3d(1.3,1.3,1.3)
        }

        40% {
            -webkit-transform: scale3d(.9,.9,.9);
            transform: scale3d(.9,.9,.9)
        }

        60% {
            opacity: 1;
            -webkit-transform: scale3d(1.03,1.03,1.03);
            transform: scale3d(1.03,1.03,1.03)
        }

        80% {
            -webkit-transform: scale3d(.97,.97,.97);
            transform: scale3d(.97,.97,.97)
        }

        100% {
            opacity: 1;
            -webkit-transform: scale3d(1,1,1);
            transform: scale3d(1,1,1)
        }
    }

    @keyframes bounceIn {
        0%,100%,20%,40%,60%,80% {
            -webkit-transition-timing-function: cubic-bezier(0.215,.61,.355,1);
            transition-timing-function: cubic-bezier(0.215,.61,.355,1)
        }

        0% {
            opacity: 0;
            -webkit-transform: scale3d(.1,.1,.1);
            -ms-transform: scale3d(.1,.1,.1);
            transform: scale3d(.1,.1,.1)
        }

        20% {
            -webkit-transform: scale3d(1.3,1.3,1.3);
            -ms-transform: scale3d(1.3,1.3,1.3);
            transform: scale3d(1.3,1.3,1.3)
        }

        40% {
            -webkit-transform: scale3d(.9,.9,.9);
            -ms-transform: scale3d(.9,.9,.9);
            transform: scale3d(.9,.9,.9)
        }

        60% {
            opacity: 1;
            -webkit-transform: scale3d(1.03,1.03,1.03);
            -ms-transform: scale3d(1.03,1.03,1.03);
            transform: scale3d(1.03,1.03,1.03)
        }

        80% {
            -webkit-transform: scale3d(.97,.97,.97);
            -ms-transform: scale3d(.97,.97,.97);
            transform: scale3d(.97,.97,.97)
        }

        100% {
            opacity: 1;
            -webkit-transform: scale3d(1,1,1);
            -ms-transform: scale3d(1,1,1);
            transform: scale3d(1,1,1)
        }
    }

    .bounceIn {
        -webkit-animation-name: bounceIn;
        animation-name: bounceIn;
        -webkit-animation-duration: .75s;
        animation-duration: .75s
    }
    .essenceIcon{
        right: 0;
        top:5px;
        width: 60px;
        height: 25px;
        background-image: url('//image1.51tiangou.com/tgou2/img2/overseas/jinghua.svg');
        background-repeat: no-repeat;
        background-size: 60px 25px;
    }
    .recommendIcon{
        right: 0;
        top:-0.556rem;
        width: 18px;
        height: 26px;
        background-image: url('//image1.51tiangou.com/tgou2/img2/overseas/tui.svg');
        background-repeat: no-repeat;
        background-size: 18px 26px;
    }
    .quan{
        width: 22px;
        line-height: 18px;
        overflow: hidden;
    }
    .quan.col{
        width: 20px;
        line-height: 14px;
        overflow: hidden;
    }
    .quan span{
        border: 1px solid #ff4c48;
        background: #FFF6F6;
        width: 100%;
        height: 100%;
        display: block;
    }
    .quan:after,.quan:before{
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        border: 1px solid #ff4c48;
        background-color: #fff;
        top: 5px;
    }
    .quan:after{
        right: -3px;
    }
    .quan:before{
        left: -3px;
    }
    .iconDown{
        transform: rotate(90deg);
        transform-origin: 50% 50%;
        -ms-transform: rotate(90deg);
        -ms-transform-origin: 50% 50%;
        -webkit-transform: rotate(90deg);
        -webkit-transform-origin: 50% 50%;
        -moz-transform: rotate(90deg);
        -moz-transform-origin: 50% 50%;
        -o-transform: rotate(90deg);
        -o-transform-origin: 50% 50%;
    }
    .iconUp{
        transform: rotate(270deg);
        transform-origin: 50% 50%;
        -ms-transform: rotate(270deg);
        -ms-transform-origin: 50% 50%;
        -webkit-transform: rotate(270deg);
        -webkit-transform-origin: 50% 50%;
        -moz-transform: rotate(270deg);
        -moz-transform-origin: 50% 50%;
        -o-transform: rotate(270deg);
        -o-transform-origin: 50% 50%;
    }
</style>